import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Provider } from '@angular/core';
import { DuplicateSessionInterceptor } from './duplicateSession.interceptor';
export const httpInterceptorProviders: Provider[] = [
    {
        provide: HTTP_INTERCEPTORS, useClass: DuplicateSessionInterceptor, multi: true
    }
];
